<template>
  <v-container>
    <v-dialog v-model="this.dialogRegistrada" max-width="290">
      <v-card>
        <v-card-title class="text-h5"> {{ this.tituloMensaje }} </v-card-title>
        <v-card-text>
          {{ this.textoMensaje }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue darken-1" text @click="dialogRegistrada = false">
            ACEPTAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row class="mt-2" justify="center">
      <v-col md="5" justify="center">
        <v-card
          v-if="!user"
          class="mt-2 elevation-12"
          color="rgb(100, 100, 100, 0.9)"
        >
          <v-toolbar height="150" dense color="blue" flat>
            <v-col>
              <v-row class="mb-0 mt-0" justify="center">
                <v-img
                  alt="Piraguilla Logo"
                  class="shrink ml-2 mr-2"
                  contain
                  src="../assets/icono.png"
                  transition="scale-transition"
                  width="300"
                  height="100"
                />
              </v-row>
              <v-row class="mb-2 mt-0" justify="center">
                <h3>
                  {{
                    this.reserva != null ? this.reserva.actividad.nombre : ""
                  }}
                </h3>
              </v-row>

              <v-row dense>
                <v-col align="center">
                  <v-chip class="ml-4 mr-4 px-4" color="#0D47A1">
                    <v-avatar left>
                      <v-icon>mdi-calendar</v-icon>
                    </v-avatar>
                    <h4>
                      {{
                        reserva != null
                          ? new Date(reserva.fecha).toLocaleDateString(
                              "es-ES",
                              {
                                weekday: "long",
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                              }
                            )
                          : ""
                      }}
                    </h4>
                  </v-chip>
                </v-col>

                <!--   <v-col align="center">
                  <v-chip class="px-3" color="green">
                    <v-avatar left>
                      <v-icon>mdi-clock</v-icon>
                    </v-avatar>
                    <h4>
                      {{ reserva != null ? reserva.hora : "" }}
                    </h4>
                  </v-chip>
                </v-col> -->
              </v-row>
            </v-col>
          </v-toolbar>

          <v-card-text>
            <v-form @submit.prevent="$emit('login')" id="login-form">
              <v-text-field
                class="mr-4 ml-4 mt-6"
                v-model="userNew.nombre"
                label="Nombre y Apellidos"
                name="nombre"
                prepend-icon="mdi-account-circle"
                type="text"
                autocomplete="off"
                outlined
                dense
              >
              </v-text-field>

              <v-text-field
                class="mr-4 ml-4"
                v-model="userNew.telefono1"
                label="Teléfono"
                name="telefono"
                prepend-icon="mdi-phone-classic"
                type="text"
                autocomplete="off"
                outlined
                dense
              >
              </v-text-field>
              <v-text-field
                class="mr-4 ml-4"
                v-model="userNew.email"
                label="Email"
                name="email"
                prepend-icon="mdi-email-open"
                type="text"
                autocomplete="off"
                outlined
                dense
              >
              </v-text-field>

              <v-text-field
                class="mr-4 ml-4"
                v-model="userNew.dni"
                label="DNI/NIE"
                name="dni"
                prepend-icon="mdi-contacts"
                type="text"
                autocomplete="off"
                outlined
                dense
              >
              </v-text-field>

              <v-text-field
                v-model="userNew.fecha_nac"
                label="Fecha de Nacimiento"
                prepend-icon="mdi-calendar"
                type="date"
                class="ml-4 mr-4"
                outlined
                dense
                autocomplete="off"
              ></v-text-field>

              <v-checkbox class="ml-4" v-model="checkpolitica" color="blue">
                <template v-slot:label>
                  <div>
                    Estoy de acuerdo con la

                    <a
                      target="_blank"
                      href="https://www.piraguilla.com/politica-privacidad/"
                      @click.stop
                    >
                      política de privacidad
                    </a>
                  </div>
                </template>
              </v-checkbox>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  class="mt-4 pl-8 pr-8"
                  color="#0D47A1"
                  @click="_registrar"
                  v-bind:style="{ color: colorBase }"
                  :disabled="
                    !checkpolitica ||
                      userNew.nombre == null ||
                      userNew.nombre == ''
                  "
                >
                  Registrar como acompañante
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-form>

            <!--  <registro-form class="mb-6" :userNew="userNew" @login="submit"> </registro-form> -->
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import base64url from "base64url";
import Modal from "@/components/Modal";
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  components: {
    Modal,
  },

  data() {
    return {
      tituloMensaje: "Registro Satisfactorio",
      textoMensaje: "Ha sido registrado como acompañante de la actividad",
      reserva: null,
      checkpolitica: false,
      dialogRegistrada: false,
      id: "",
      userNew: {
        id: null,
        cp: null,
        nombre: null,
        foto: null,
        telefono1: null,
        web: null,
        telefono2: null,
        trabajo: null,
        email: null,
        sexo: null,
        localidad: null,
        gustos: null,
        provincia: null,
        autonomia: null,
        instagram: null,
        descripcion: null,
        facebook: null,
        fecha_nac: null,
        comentario_canoe: null,
        res: null,
        dni: null,
        comentario_cliente: null,
      },
      userSelec: null,
    };
  },

  computed: {
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState(["colorBoton", "colorBase"]),
  },

  mounted() {
    if (this.$route.params.id) {
      this.id = base64url.decode(this.$route.params.id);
      this._getDatosReserva(this.id);
    }
  },

  methods: {
    ...mapActions("auth", ["getDatosReserva", "registrarAcompañante"]),

    async _registrar() {
      let res = await this.registrarAcompañante([this.id, this.userNew]);
      console.log(res);
      if (res.error) {
        this.tituloMensaje = "Error en el registro";
      } else {
        this.tituloMensaje = "Registrado";
      }
      this.textoMensaje = res.mensaje;
      this.dialogRegistrada = true;
      this.userNew.nombre = "";
      this.userNew.telefono1 = "";
      this.userNew.email = "";
      this.userNew.dni = "";
      this.userNew.fecha_nac = "";
    },

    async _getDatosReserva(id) {
      this.reserva = await this.getDatosReserva([id]);
    },
  },
};
</script>
